function getPaymentsWithId(_ref) {
  let {
    paymentInfo,
    walletId,
    showSyncAlert,
    isManualSync
  } = _ref;
  if (!paymentInfo?.walletId) {
    // make sure we store walletId if not already
    paymentInfo.walletId = walletId;
  }
  if (showSyncAlert) {
    paymentInfo.interactions = {
      ...paymentInfo.interactions,
      syncAlert: {
        showAlert: true,
        success: true,
        isAuto: !isManualSync
      }
    };
  }
  return {
    paymentInfo
  };
}
export { getPaymentsWithId as default };
